// extracted by mini-css-extract-plugin
export default {"dropZone":"EIcSQpqJKVC38rd1crAv","dropZoneActive":"yaQPvclrDgJEGabFCFJL","chipSelected":"VfBQXX0AUky7DjhSQG0R","chipAvailable":"yrbd4Np2SivhqGJs3UZb"};